// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"ea30fc86","938":"a0280ca7"}[chunkId] + ".chunk.js";
};